import { createSelector } from 'reselect';
import CPF from 'gerador-validador-cpf';

export const Types = {
  GET_LIST_REQUEST: 'attendances/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'attendances/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'attendances/GET_LIST_FAILURE',

  CREATE_REQUEST: 'attendances/CREATE_REQUEST',
  CREATE_SUCCESS: 'attendances/CREATE_SUCCESS',
  CREATE_FAILURE: 'attendances/CREATE_FAILURE',

  GET_DASHBOARD_REQUEST: 'attendances/GET_DASHBOARD_REQUEST',
  GET_DASHBOARD_SUCCESS: 'attendances/GET_DASHBOARD_SUCCESS',
  GET_DASHBOARD_FAILURE: 'attendances/GET_DASHBOARD_FAILURE',

  SELECT_ALL_REQUEST: 'attendances/SELECT_ALL_REQUEST',
  SELECT_REQUEST: 'attendances/SELECT_REQUEST',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  total: 0,

  dashboard: {
    data: {
      absents: 0,
      confirmeds: 0,
      not_informed: 0,
      presents: 0,
    },
    loading: true,
  },

  create: {
    loading: false,
  },
};

export default function attendances(state = initialState, action) {
  switch (action.type) {
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.attendances.data,
        page: action.payload.attendances.meta.current_page,
        total: action.payload.attendances.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.GET_DASHBOARD_REQUEST:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: true,
        },
      };
    case Types.GET_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: false,
          data: action.payload.dashboard,
        },
      };
    case Types.GET_DASHBOARD_FAILURE:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: false,
        },
      };
    case Types.SELECT_ALL_REQUEST:
      return {
        ...state,
        data: state.data.map(attendance => ({
          ...attendance,
          attributes: {
            ...attendance.attributes,
            selected: !attendance.attributes.selected,
          },
        })),
      };
    case Types.SELECT_REQUEST:
      return {
        ...state,
        data: state.data.map(attendance => ({
          ...attendance,
          attributes: {
            ...attendance.attributes,
            selected:
              attendance.id === action.payload.id ? !attendance.attributes.selected : attendance.attributes.selected,
          },
        })),
      };
    default:
      return state;
  }
}

export const Creators = {
  getAttendancesRequest: (id, page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { id, page, filters },
  }),

  getAttendancesSuccess: attendances => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { attendances },
  }),

  getAttendancesFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createAttendanceRequest: (id, data) => ({
    type: Types.CREATE_REQUEST,
    payload: { id, data },
  }),

  createAttendanceSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createAttendanceFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  getAttendancesDashboardRequest: id => ({
    type: Types.GET_DASHBOARD_REQUEST,
    payload: { id },
  }),

  getAttendancesDashboardSuccess: dashboard => ({
    type: Types.GET_DASHBOARD_SUCCESS,
    payload: { dashboard },
  }),

  getAttendancesDashboardFailure: () => ({
    type: Types.GET_DASHBOARD_FAILURE,
  }),

  selectAttendancesRequest: () => ({
    type: Types.SELECT_ALL_REQUEST,
  }),

  selectAttendanceRequest: id => ({
    type: Types.SELECT_REQUEST,
    payload: { id },
  }),
};

const getStatus = status => {
  switch (status) {
    case 'absent':
      return { name: 'Ausente', className: 'label-pendent' };
    case 'present':
      return { name: 'Presente', className: 'label-active' };
    default:
      return { name: 'Não marcado', className: 'label-inactive' };
  }
};

export const Selectors = {
  list: createSelector(
    state => state,
    attendances =>
      attendances.map(attendance => ({
        ...attendance,
        attributes: {
          ...attendance.attributes,
          document: CPF.format(attendance.attributes.document),
          status: getStatus(attendance.attributes.attendance_status),
        },
      })),
  ),
};
